import {CApiNotification} from './CApiNotification';

import type {JsonObject} from '../../../../HeliportJS/dist/models/json';
export class CAchievementApiNotification {
  addPersonalEvent(fn: (params: JsonObject) => void) {
    CApiNotification.addEventListener('Personal', 'Achievement', fn);
  }
}
